import React from 'react';
import {
  Table as MuiTable,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';

export interface Column<T> {
  key: string;
  label: string;
  render?: (value: any, row: T, index: number) => React.ReactNode;
  width?: string | number;
  minWidth?: string | number;
  align?: 'left' | 'center' | 'right';
}

export interface TableProps<T> {
  columns: Column<T>[];
  data: T[];
  sx?: any;
  containerSx?: any;
}

function Table<T extends Record<string, any>>({
  columns,
  data,
  sx = {},
  containerSx = {}
}: TableProps<T>) {
  return (
    <TableContainer component={Paper} sx={{ borderRadius: 1, overflow: 'hidden', ...containerSx }}>
      <MuiTable sx={{ ...sx }}>
        <TableHead>
          <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
            {columns.map((column) => (
              <TableCell
                key={column.key}
                sx={{
                  padding: '12px 16px',
                  fontWeight: 600,
                  borderBottom: '1px solid #e0e0e0',
                  minWidth: column.minWidth,
                  width: column.width,
                  textAlign: column.align || 'left'
                }}
              >
                {column.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, rowIndex) => (
            <TableRow key={rowIndex} sx={{ borderBottom: '1px solid #e0e0e0' }}>
              {columns.map((column) => (
                <TableCell
                  key={column.key}
                  sx={{
                    padding: '12px 16px',
                    textAlign: column.align || 'left'
                  }}
                >
                  {column.render
                    ? column.render(row[column.key], row, rowIndex)
                    : row[column.key]
                  }
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </MuiTable>
    </TableContainer>
  );
}

export default Table;
